// Story 7.6 — platform_dossier card. STUB for future dossier surfacing:
// the dossier metadata the feed carries today and a "View dossier" CTA
// into the existing marketplace path (Story 5.5's BuyListingConfirmModal
// flow lives there). No new purchase surface.
// Epic 8 — rendered on parchment (ParchmentPost).

import { useState } from "react";
import { Link } from "react-router-dom";

import { ParchmentPost, isLoadableImageUrl } from "@greenhold/components";

import { parchmentCtaClass, relativeTime, wearSeed } from "./feedCardShared";
import type { FeedCard } from "./useFeed";

export function DossierCard({ card }: { card: FeedCard }) {
  const [mediaError, setMediaError] = useState(false);

  return (
    <ParchmentPost
      author="Greenhold"
      provenance="editorial"
      time={relativeTime(card.published_at)}
      title={card.title}
      pinned={card.is_pinned}
      seed={wearSeed(card.id)}
    >
      {isLoadableImageUrl(card.media_url) && !mediaError ? (
        <img
          src={card.media_url ?? undefined}
          alt=""
          loading="lazy"
          onError={() => setMediaError(true)}
          className="mb-3 max-h-80 w-full rounded object-cover first:mt-0"
        />
      ) : null}
      {card.body ? <p className="m-0">{card.body}</p> : null}
      <p className="m-0 mt-3">
        <Link
          to="/marketplace"
          className={parchmentCtaClass}
          data-testid="dossier-cta"
        >
          View dossier →
        </Link>
      </p>
    </ParchmentPost>
  );
}
